export default "__VITE_ASSET__1PPOwnS6__"